export function megaMenu() {
	/**
	 * Mega Menu Functionality
	 * Handles hover interactions for mega navigation menu
	 */

	const megaNav = document.querySelector('.mega-nav')

	if (!megaNav) {
		return // Exit if mega-nav doesn't exist
	}

	const menuToggleItems = megaNav.querySelectorAll('.menu-toggle')
	const subMenus = megaNav.querySelectorAll('.mega-nav__sub')

	// Function to show submenu
	function showSubMenu(menuIndex) {
		const targetSubMenu = megaNav.querySelector(`.mega-nav__sub[data-menu-index="${menuIndex}"]`)
		if (targetSubMenu) {
			targetSubMenu.classList.add('active')
			// Make submenu focusable
			targetSubMenu.removeAttribute('aria-hidden')
			const focusableElements = targetSubMenu.querySelectorAll('a, button, [tabindex]')
			focusableElements.forEach((element) => {
				element.removeAttribute('tabindex')
			})
		}
	}

	// Function to hide submenu
	function hideSubMenu(menuIndex) {
		const targetSubMenu = megaNav.querySelector(`.mega-nav__sub[data-menu-index="${menuIndex}"]`)
		if (targetSubMenu) {
			targetSubMenu.classList.remove('active')
			// Make submenu not focusable
			targetSubMenu.setAttribute('aria-hidden', 'true')
			const focusableElements = targetSubMenu.querySelectorAll('a, button, [tabindex]')
			focusableElements.forEach((element) => {
				element.setAttribute('tabindex', '-1')
			})
		}
	}

	// Function to hide all submenus
	function hideAllSubMenus() {
		subMenus.forEach((subMenu) => {
			subMenu.classList.remove('active')
			// Make submenu not focusable
			subMenu.setAttribute('aria-hidden', 'true')
			const focusableElements = subMenu.querySelectorAll('a, button, [tabindex]')
			focusableElements.forEach((element) => {
				element.setAttribute('tabindex', '-1')
			})
		})
	}

	// Initialize all submenus as hidden and not focusable
	subMenus.forEach((subMenu) => {
		subMenu.setAttribute('aria-hidden', 'true')
		const focusableElements = subMenu.querySelectorAll('a, button, [tabindex]')
		focusableElements.forEach((element) => {
			element.setAttribute('tabindex', '-1')
		})
	})

	// Add event listeners to menu toggle items
	menuToggleItems.forEach((menuItem) => {
		const menuIndex = menuItem.getAttribute('data-menu-index')

		// Mouse enter event
		menuItem.addEventListener('mouseenter', function () {
			hideAllSubMenus() // Hide all other submenus first
			showSubMenu(menuIndex)
		})

		// Mouse leave event
		menuItem.addEventListener('mouseleave', function () {
			// Add a small delay to allow moving to submenu
			setTimeout(() => {
				const targetSubMenu = megaNav.querySelector(`.mega-nav__sub[data-menu-index="${menuIndex}"]`)
				if (targetSubMenu && !targetSubMenu.matches(':hover') && !menuItem.matches(':hover')) {
					hideSubMenu(menuIndex)
				}
			}, 300)
		})
	})

	// Add event listeners to submenus to keep them open when hovering
	subMenus.forEach((subMenu) => {
		const menuIndex = subMenu.getAttribute('data-menu-index')

		subMenu.addEventListener('mouseenter', function () {
			subMenu.classList.add('active')
		})

		subMenu.addEventListener('mouseleave', function () {
			hideSubMenu(menuIndex)
		})
	})

	// Close all submenus when clicking outside
	document.addEventListener('click', function (event) {
		if (!megaNav.contains(event.target)) {
			hideAllSubMenus()
		}
	})

	// Handle keyboard navigation for accessibility
	menuToggleItems.forEach((menuItem) => {
		menuItem.addEventListener('keydown', function (event) {
			const menuIndex = menuItem.getAttribute('data-menu-index')

			if (event.key === 'Enter' || event.key === ' ') {
				event.preventDefault()
				const targetSubMenu = megaNav.querySelector(`.mega-nav__sub[data-menu-index="${menuIndex}"]`)
				if (targetSubMenu) {
					if (targetSubMenu.classList.contains('active')) {
						hideSubMenu(menuIndex)
					} else {
						hideAllSubMenus()
						showSubMenu(menuIndex)
					}
				}
			} else if (event.key === 'Escape') {
				hideAllSubMenus()
			}
		})
	})

	// Monitor mega-nav height and toggle "no-mega" class on site header
	function checkMegaNavHeight() {
		const siteHeader = document.querySelector('.site__header')
		if (!siteHeader) return

		const megaNavHeight = megaNav.getBoundingClientRect().height

		if (megaNavHeight > 85) {
			siteHeader.classList.add('no-mega')
		} else {
			siteHeader.classList.remove('no-mega')
		}
	}

	// Check height on initial load
	checkMegaNavHeight()

	// Monitor for height changes using ResizeObserver
	if (window.ResizeObserver) {
		const resizeObserver = new ResizeObserver(() => {
			checkMegaNavHeight()
		})
		resizeObserver.observe(megaNav)
	}

	// Fallback for older browsers - check on window resize
	window.addEventListener('resize', checkMegaNavHeight)
}
